<template>
  <div class="hp-manager-page-list">
    <filter-from :filter='filter' @handleSubmit="handleSubmit">
      <span slot="button">
        <a-button type="primary" @click="handleEdit(0)">新增</a-button>
      </span>
    </filter-from>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a @click="selected(rowKey.data)">选择</a>
        </span>
      </template>
    </standard-table>
    <hp-manager-modal width="500px" :title="title" v-model="addVisible">
      <hp-manager-page-dealerAddress-add slot="slot" @submit-success="refreshCurrent" @cancel="addVisible = false" :params="params"></hp-manager-page-dealerAddress-add>
    </hp-manager-modal>
  </div>
</template>


<script>
import { api } from "@/common";
import filterFrom from "@/components/filter/filter";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";

import hpManagerPageDealerAddressAdd from "./AddDealerAdderss";
export default {
  // name: "hp-manager-page-dealer-select",
  mixins: [account, dateFormat, moneyFormat],
  components: {
    filterFrom,
    hpManagerPageDealerAddressAdd
  },
  // 接受属性
  props: {
    paramsX: Object
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "name",
          name: "名称"
        },
        {
          type: "input",
          key: "code",
          name: "编码"
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 70,
          scopedSlots: { customRender: "action" },
          fixed: "left"
        },
        {
          title: "联系人",
          dataIndex: "contact",
          width: 140,
          sorter: true
        },
        {
          title: "联系电话",
          dataIndex: "telephone",
          width: 140,
          sorter: true
        },
        {
          title: "地址",
          dataIndex: "fullAddress"
        },
        {
          title: "默认地址",
          dataIndex: "isDefault",
          width: 100,
          customRender: (text, row, index) => {
            return row.isDefault ? "是" : "否";
          }
        },
        {
          title: "来自金蝶",
          dataIndex: "isFromErp",
          width: 100,
          customRender: (text, row, index) => {
            return row.isFromErp ? "是" : "否";
          }
        }
      ],
      datas: [],
      filterdata: Object.assign(JSON.parse(JSON.stringify(config.pageFilter))),
      pagination: JSON.parse(JSON.stringify(config.page)),
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      dealerId: 0,
      addVisible: false,
      params: {},
      title: ""
    };
  },
  async mounted() {
    this.dealerId = this.paramsX.dealerId;
    this.getDatas(this.filterdata);
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },

    selected(record) {
      this.$emit("getSelectedDealerAddress", record);
    },

    refreshCurrent() {
      this.addVisible = false;
      this.pagination.current = 0;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },
    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.isabl = false;
      if (type == 1) {
        this.title = "编辑地址";
      } else if (type == 2) {
        this.title = "地址详情";
        this.isabl = true;
      } else {
        this.title = "新增地址";
      }
      this.params = Object.assign(
        { isShow: this.isabl, dealerId: this.dealerId },
        record
      );
      this.addVisible = true;
    },
    async getDatas(options) {
      this.loading = true;
      options.dealerId = this.dealerId;
      let data = await api.GetDealerAddressList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/router/Basic/Dealer/SelectDealerAddress.vue